<template>
    <v-container
        fluid
        grid-list-xl>
        <v-layout
            justify-center
            wrap>
        <!-- <v-flex
            md12> -->
        <v-card
        elevation="2"
        class="card-body">
        <v-card>
            <v-card-title>{{ $t('subcategories.title')}}  {{ getCategory.name }} </v-card-title>
        </v-card>
        <v-spacer/>
        <div>
        <v-btn
            dark
            class="add-new mb-1 mt-8 mr-3"
            @click="openNewSubcategpry()">{{ $t('subcategories.newSubcategory') }}</v-btn>
        </div>
          <v-text-field
            v-model="search"
            :search="search"
            :label="$t('search')"
            :placeholder="$t('search')"
            single-line
            hide-details
            class="search-field">
            </v-text-field>
            <v-data-table
              :headers="headers"
              :items="getSubcategories"
              :rows-per-page-items ="rowsAmount"
              :search="search"
              class="elevation-1"
            >
              <template v-slot:item="props">   
                <tr>          
                <td class="justify-center icon-table-wrap">
                      <v-icon
                          medium
                          class="icon-table"
                          @click="openEditSubcategpry(props)">mdi-pencil</v-icon>
                  </td>
                  <td class="justify-center icon-table-wrap">
                      <v-icon
                          medium
                          class="icon-table"
                          @click="deleteSubcategory(props)">mdi-delete</v-icon>
                  </td> 
                  <td>
                    <div>{{ props.item.name }}</div>
                  </td>             
                  <td>
                    <div v-if="props.item.image">
                        <img class="table-image" v-bind:src=props.item.image>
                    </div>
                    <div v-else>---</div>
                  </td>  
                </tr>             
              </template>
            </v-data-table>
        </v-card>
      <!-- </v-flex> -->
    </v-layout>
  </v-container>
</template>

<script>
  import {  mapGetters } from 'vuex';
  import i18n from '../../i18n'
  export default {
      data () {
          return {
              search: '',
              rowsAmount: [10,20,25,{"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}],
              headers: [
                  { text: i18n.t(''),},
                  { text: i18n.t(''),},
                  { text: i18n.t('subcategories.name'), value: 'name'},
                  { text: i18n.t('subcategories.image'), value: 'image'},
              ],
          }
      },
      computed: {
        ...mapGetters([
            'getAllCategories',
            'getCategory',
            'getAllProducts'
        ]),
        getSubcategories(){
          const categoryId = localStorage.getItem('categoryId')

            let subcategories = [];
                this.getAllCategories.forEach(el => {
                if(el.id == categoryId){
                   subcategories = el.subcategories;
                }            
            });
            return subcategories;
        },
      },
      methods:{
        openNewSubcategpry(){
          localStorage.setItem('categoryName', this.getCategory.name);
          this.$router.push(`/${i18n.locale}/categories/subcategories/add-new-subcategory`);
        },
        openEditSubcategpry(props){
          localStorage.setItem('categoryName', this.getCategory.name);
          this.$router.push(`/${i18n.locale}/categories/subcategories/edit-subcategory/${props.item.id}`);
        },
        deleteSubcategory(props){
            if (confirm(i18n.t(`areYouSureToDelete_`) + `${props.item.name}?`)) {
              this.$store.dispatch('DELETE_CATEGORY', props.item.id)
                  .then(() => this.$store.dispatch('LOAD_ALL_CATEGORIES'));
            }
        },
      },
      beforeCreate() {
          this.$store.dispatch('LOAD_ALL_CATEGORIES'); 
          this.$store.dispatch('LOAD_ALL_PRODUCTS');
      },
      mounted() {
          this.$store.dispatch('LOAD_ALL_CATEGORIES');
          this.$store.dispatch('LOAD_ALL_PRODUCTS');
      },
  }
</script>

<style lang="less">

</style>